module.exports = __webpack_public_path__ + "img/bg-element-round-big.1fd01425.png";